import { Outlet, NavLink } from "react-router-dom";
import "../styles/ManagementLayout.css";

export default function ManagementLayout() {
  return (
    <div className="management-container">
      <nav className="management-nav">
        <NavLink
          to="contacts"
          end
          className={({ isActive }) =>
            isActive ? "management-tab active-tab" : "management-tab"
          }
        >
          Contacts
        </NavLink>
        <NavLink
          to="orders"
          className={({ isActive }) =>
            isActive ? "management-tab active-tab" : "management-tab"
          }
        >
          Orders
        </NavLink>
        <NavLink
          to="emails"
          className={({ isActive }) =>
            isActive ? "management-tab active-tab" : "management-tab"
          }
        >
          Emails
        </NavLink>
        <NavLink
          to="returns"
          className={({ isActive }) =>
            isActive ? "management-tab active-tab" : "management-tab"
          }
        >
          Returns &amp; Exchanges
        </NavLink>
        <NavLink
          to="stock"
          className={({ isActive }) =>
            isActive ? "management-tab active-tab" : "management-tab"
          }
        >
          Stock
        </NavLink>
        <NavLink
          to="affiliates"
          className={({ isActive }) =>
            isActive ? "management-tab active-tab" : "management-tab"
          }
        >
          Affiliates
        </NavLink>
        <NavLink
          to="affiliates-throughput"
          className={({ isActive }) =>
            isActive ? "management-tab active-tab" : "management-tab"
          }
        >
          Affiliates Throughput
        </NavLink>
      </nav>
      <div className="management-content">
        <Outlet />
      </div>
    </div>
  );
}
